import { Pipe, PipeTransform } from '@angular/core';

import { map } from 'lodash';

@Pipe({
    name: 'keys',
    pure: false
})
export class KeysPipe implements PipeTransform {

    transform(value: any, args: any[] = null): any {
        if (typeof value == 'undefined') {
            return [];
        }

        return map(value, (val, key) => {
            return {
                key: key,
                value: val
            };
        });
    }

}


// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/pipes/keys.pipe.ts